import { Dispatch, useState } from 'react';
import { EllaAction, EllaState } from '../Ella/Ella';
import { useUser } from '@/components/hook/user';

import Button from '@/components/common/Button/Button';
import Text from '@/components/common/Text/Text';

import { isValidVivrelleSku } from '@/util/regexp';
import { redirect } from 'next/navigation';
import { EllaPromptObject } from '@/types/Ella';

export type WishlistCtasProps = {
  className?: string;
  handleShowCart?: () => void;
  handlePromptClick?: (e: any, prompt: EllaPromptObject) => void;
  state: EllaState;
  dispatch: Dispatch<EllaAction>;
};

export function WishlistCtas(props: WishlistCtasProps) {
  const { value: user } = useUser();
  const { className = '', handleShowCart, state, dispatch } = props;
  const { cart } = state;
  let wishlistUpdated = false;
  const [disabledButtons, setDisabledButtons] = useState(false);
  const [onlyVivrelleItem, setOnlyVivrelleItem] = useState(false);

  const handleWishlistingShowCart = async () => {
    // FIXME: if user is logout we need to request login
    if (user && cart.length > 0) {
      setDisabledButtons(true);
      await Promise.all(
        cart.map(async (item) => {
          // If the sku is not valid, return
          if (!isValidVivrelleSku(item.sku)) {
            return;
          }

          await fetch('/api/wishlist', {
            method: 'POST',
            body: JSON.stringify({
              sku: item.sku,
              userId: user.id
            }),
            headers: {
              'content-type': 'application/json'
            }
          });
          wishlistUpdated = true;
        })
      );

      dispatch({
        type: 'WISHLIST_ADD_ITEM',
        payload: {
          wishlistUpdated
        }
      });
      setDisabledButtons(false);

      // If the only product on the ella cart is a vivrelle item, show two new buttons: Start a new chat/Back to home
      if (
        cart.length === 0 ||
        (cart.length === 1 && isValidVivrelleSku(cart[0].sku))
      ) {
        setOnlyVivrelleItem(true);
        return;
      }

      if (handleShowCart) {
        handleShowCart();
      }
    }
  };

  // Handle cart
  // If the only product on the ella cart is a vivrelle item, show two new buttons: Start a new chat/Back to home
  const handleCart = () => {
    if (
      cart.length === 0 ||
      (cart.length === 1 && isValidVivrelleSku(cart[0].sku))
    ) {
      setOnlyVivrelleItem(true);
      return;
    }

    if (handleShowCart) {
      handleShowCart();
    }
  };

  // As part of the wishlist CTA
  // If the only product on the ella cart is a vivrelle item, show two buttons: Start a new chat/Back to home
  // Otherwise, show the normal wishlist CTA (Add to wishlist/No)
  return (
    <>
      {onlyVivrelleItem ? (
        <>
          <Button
            onClick={() => dispatch({ type: 'START_NEW_CHAT' })}
            variant='pink-400'
            disabled={disabledButtons}
          >
            Start a new chat
          </Button>
          <Button
            onClick={() => redirect('/')} // FIXME: redirect to home
            variant='pink-400'
            disabled={disabledButtons}
          >
            Back to home
          </Button>
        </>
      ) : (
        <>
          <Text
            className={'content'}
            variant='text-s'
          >
            Looks like your Vivrelle closet is already full — would you like to
            add this bag to your wishlist instead?
          </Text>
          <Button
            onClick={handleWishlistingShowCart}
            variant='pink-400'
            disabled={disabledButtons}
          >
            Yes
          </Button>
          {handleShowCart ? (
            <Button
              className='EllaMessages-product-btn-alt'
              onClick={handleCart}
              disabled={disabledButtons}
            >
              No
            </Button>
          ) : null}
        </>
      )}
    </>
  );
}
